

export class WeekendSettingDto implements IWeekendSettingDto {
    companyId!: number;
    id!: number;
    day!: string | undefined;
    firstWeek!: boolean;
    secondWeek!: boolean;
    thirdWeek!: boolean;
    fourthWeek!: boolean;
    fifthWeek!: boolean;
    isLastDayWorking!: boolean;

    constructor(data?: IWeekendSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.id = _data["id"];
            this.day = _data["day"];
            this.firstWeek = _data["firstWeek"];
            this.secondWeek = _data["secondWeek"];
            this.thirdWeek = _data["thirdWeek"];
            this.fourthWeek = _data["fourthWeek"];
            this.fifthWeek = _data["fifthWeek"];
            this.isLastDayWorking = _data["isLastDayWorking"];
        }
    }

    static fromJS(data: any): WeekendSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new WeekendSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["id"] = this.id;
        data["day"] = this.day;
        data["firstWeek"] = this.firstWeek;
        data["secondWeek"] = this.secondWeek;
        data["thirdWeek"] = this.thirdWeek;
        data["fourthWeek"] = this.fourthWeek;
        data["fifthWeek"] = this.fifthWeek;
        data["isLastDayWorking"] = this.isLastDayWorking;
        return data; 
    }
}

export interface IWeekendSettingDto {
    companyId: number;
    id: number;
    day: string | undefined;
    firstWeek: boolean;
    secondWeek: boolean;
    thirdWeek: boolean;
    fourthWeek: boolean;
    fifthWeek: boolean;
    isLastDayWorking: boolean;
}

